import {
  FloatingArrow,
  UseFloatingOptions,
  arrow,
  offset,
  flip,
  shift,
  useFloating,
  useHover,
  useInteractions,
  FloatingPortal,
} from '@floating-ui/react'
import cn from 'classnames'
import React, { useRef, useState } from 'react'

import styles from './TooltipV2.module.scss'

interface TooltipV2Props extends React.PropsWithChildren<UseFloatingOptions> {
  content: React.ReactNode
  disabled?: boolean
  variant?: 'default' | 'dark'
  className?: string
}

// TODO - make it reusable
function TooltipV2({
  content,
  disabled,
  placement = 'right',
  variant = 'default',
  children,
  className,
  ...props
}: TooltipV2Props) {
  const [isOpen, setIsOpen] = useState(false)
  const arrowRef = useRef(null)

  const { refs, floatingStyles, context } = useFloating({
    open: !disabled && isOpen,
    onOpenChange: setIsOpen,
    placement,
    middleware: [
      offset(20),
      arrow({
        element: arrowRef,
      }),
      flip(),
      shift({ padding: 5 }),
    ],
    ...props,
  })

  const hover = useHover(context)

  const { getReferenceProps, getFloatingProps } = useInteractions([hover])

  return (
    <>
      {React.cloneElement(children as React.ReactElement, {
        ref: refs.setReference,
        ...getReferenceProps(),
      })}
      {!disabled && isOpen && (
        <FloatingPortal>
          <div
            ref={refs.setFloating}
            {...getFloatingProps()}
            style={floatingStyles}
            className={cn(styles.tooltip, styles[variant], className)}
          >
            <FloatingArrow
              ref={arrowRef}
              context={context}
              height={12}
              width={18}
              tipRadius={2}
              className={cn(styles.arrow, styles[variant])}
            />
            {content}
          </div>
        </FloatingPortal>
      )}
    </>
  )
}

export default TooltipV2
